<template>
  <div>
    <i
      v-if="params.value"
      v-tooltip="`${$t('diagnosis.grid.caseGrid.lastAmendmentDate')}: <br> ${$options.filters.datetime(params.value)}`"
      class="fas fa-check success"
      aria-hidden="true"
    />
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'AmendmentIcon'
})

</script>
